var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 60,
    height: 60,
    rx: 10,
    fill: "#b895ff",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1620",
    "data-name": "Grupo 1620",
    transform: "translate(12 13.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1615",
    "data-name": "Grupo 1615",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1613",
    "data-name": "Grupo 1613",
    transform: "translate(0.951 4.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323",
    "data-name": "Caminho 323",
    d: "M1026.237,357.073H995.38a1.286,1.286,0,1,1,0-2.571h30.857a1.286,1.286,0,1,1,0,2.571Z",
    transform: "translate(-994.094 -354.502)",
    fill: "#b895ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1614",
    "data-name": "Grupo 1614",
    transform: "translate(0.951 10.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324",
    "data-name": "Caminho 324",
    d: "M1026.112,360.105H995.38a1.286,1.286,0,1,1,0-2.571h30.732a1.286,1.286,0,1,1,0,2.571Z",
    transform: "translate(-994.094 -357.534)",
    fill: "#b895ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_325",
    "data-name": "Caminho 325",
    d: "M1003.175,383.532a9.18,9.18,0,0,1-6.627-2.688,10.678,10.678,0,0,1-3.009-7.659V361.994c0-5.907,4.156-10.361,9.667-10.361h16.161a9.833,9.833,0,0,1,7.089,3.137,9.956,9.956,0,0,1,2.614,7.291l0,11.117a9.833,9.833,0,0,1-9.682,10.354h-16.214Zm16.178-29.328h-16.147c-4.113,0-7.1,3.276-7.1,7.79v11.191a8.13,8.13,0,0,0,2.254,5.839,6.661,6.661,0,0,0,4.814,1.937h16.195a7.249,7.249,0,0,0,5.194-2.313,7.36,7.36,0,0,0,1.934-5.4l0-11.265a7.411,7.411,0,0,0-1.932-5.47A7.245,7.245,0,0,0,1019.353,354.2Z",
    transform: "translate(-993.539 -351.633)",
    fill: "#b895ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1619",
    "data-name": "Grupo 1619",
    transform: "translate(4.915 16.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1617",
    "data-name": "Grupo 1617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1616",
    "data-name": "Grupo 1616",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    "data-name": "Caminho 326",
    d: "M1000.263,368.987a3.857,3.857,0,1,1,3.857-3.857A3.862,3.862,0,0,1,1000.263,368.987Zm0-5.143a1.286,1.286,0,1,0,1.286,1.286A1.287,1.287,0,0,0,1000.263,363.844Z",
    transform: "translate(-996.406 -361.273)",
    fill: "#b895ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1618",
    "data-name": "Grupo 1618",
    transform: "translate(8.877 2.571)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_327",
    "data-name": "Caminho 327",
    d: "M1009.154,365.344h-6.285a1.286,1.286,0,1,1,0-2.571h6.285a1.286,1.286,0,1,1,0,2.571Z",
    transform: "translate(-1001.584 -362.773)",
    fill: "#b895ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.2f87ce0aa004cf333686ea66885b88c3.svg";
export { ForwardRef as ReactComponent };